
// src/components/checagens/TarefasList.tsx
import React, { useState } from 'react';
import { useTarefas, useUpdateTarefaStatus } from '../../hooks/useChecagens';
import { Tarefa } from '../../models/checagens';
import NovaTarefaModal from './NovaTarefaModal';
import { PlusCircle } from 'lucide-react';
import './TarefasList.css';

interface TarefasListProps {
  checagemImovelId: number;
}

const TarefasList: React.FC<TarefasListProps> = ({ checagemImovelId }) => {
  const { data: tarefas, isLoading } = useTarefas(checagemImovelId);
  const [isModalOpen, setModalOpen] = useState(false);
  const updateStatusMutation = useUpdateTarefaStatus(checagemImovelId);

  const handleToggleStatus = (tarefa: Tarefa) => {
    const newStatus = tarefa.status === 'pendente' ? 'concluida' : 'pendente';
    updateStatusMutation.mutate({ tarefaId: tarefa.id, status: newStatus });
  };

  return (
    <div className="card tarefas-list">
      <div className="tarefas-header">
        <h3>Tarefas</h3>
        <button onClick={() => setModalOpen(true)} className="add-tarefa-btn">
          <PlusCircle size={16} /> Nova Tarefa
        </button>
      </div>
      {isLoading && <p>Carregando tarefas...</p>}
      <div className="tarefas-content">
        {tarefas?.map(tarefa => (
          <div key={tarefa.id} className={`tarefa-item ${tarefa.status}`}>
            <input 
              type="checkbox" 
              checked={tarefa.status === 'concluida'} 
              onChange={() => handleToggleStatus(tarefa)}
            />
            <div className="tarefa-details">
              <span className="tarefa-title">{tarefa.titulo}</span>
              <span className="tarefa-due-date">{tarefa.due_at || 'Sem data'}</span>
            </div>
          </div>
        ))}
        {tarefas?.length === 0 && !isLoading && <p>Nenhuma tarefa pendente.</p>}
      </div>
      {isModalOpen && (
        <NovaTarefaModal 
          checagemImovelId={checagemImovelId} 
          onClose={() => setModalOpen(false)} 
        />
      )}
    </div>
  );
};

export default TarefasList;
